import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    userInfo: {},
    unlockData: {}
  },
  mutations: {
    setUserInfo(state, data) {
      state.userInfo = data
    },
    setUnlockData(state, data) {
      state.unlockData = data
    }
  },
  modules: {
    index: {
      namespaced: true,
      state: {
        userId: "",
        dataTokn: ""
      },
      mutations: {
        setUser(state, val) {
          state.userId = val
        },
        setDataTokn(state, val) {
          state.dataTokn = val
        }
      }
    }
  }


})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js